export default __webpack_public_path__ + "static/media/ignoreRed.6a80b7be.svg";